<template>
  <div class="results manual-help">
    <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("nav.manual") }} </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results-wrap">
      <div class="headtitle">使用帮助</div>
      <div class="s1">
        <div class="s1Wrap">
          <Row :gutter="60" type="flex">
            <Col span="6"><div class="wrap"><div class="title">最优税率API</div></div></Col>
            <Col span="6"><div class="wrap"><div class="title">原产地规则API</div></div></Col>
            <Col span="6"><div class="wrap"><div class="title">原产地判定API</div></div></Col>
            <Col span="6"><div class="wrap"><div class="title">享惠分析API</div></div></Col>
          </Row>
        </div>
      </div>
      <ZX></ZX>
    </div>
  </div>
</template>

<script>
import ZX from '@/components/layout/ZX'

export default {
  name: 'HelpManual',
  components: { ZX },
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.headtitle{
  font-size: 2.6rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}
.s1{
  margin-top: 40px;
  margin-bottom: 60px;
}
.s1 .s1Wrap{
  padding: 0 30px;
}
.s1 .wrap{
  border: 0.5px solid #999;
  height: 320px;
  border-radius: 6px;
  overflow: hidden;
}
.s1 .title{
  background-color: #4472c4;
  color: #fff;
  font-size: 16px;
  text-align: center;
  padding: 30px 0;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .manual-help .headtitle{
    font-size: 3rem;
  }
  .manual-help .s1 .title{
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/Manual.vue